export default __webpack_public_path__ + "static/media/avatar_indian_boy4.f8a05261.mp3";